import { INewbuilding, INewbuildingResponse } from '../../types/newbuilding';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: INewbuilding = {
  newbuildingId: 0,
  newbuildingName: '',
  isNewbuilding: false,
};

const newBuildingSlice = createSlice({
  name: 'newbuilding',
  initialState,
  reducers: {
    setIsNebuilding: (state, action: PayloadAction<boolean>) => {
      state.isNewbuilding = action.payload;
    },
    setNewbuildingInfo: (state, action: PayloadAction<INewbuildingResponse>) => {
      state.newbuildingId = action.payload.id;
      state.newbuildingName = action.payload.name;
    },
    resetNewbuildingState: () => initialState,
  },
  extraReducers: {},
});

export const {
  reducer: newbuildingReducer,
  actions: { setIsNebuilding, setNewbuildingInfo, resetNewbuildingState },
} = newBuildingSlice;
